import React, { Fragment, useEffect, useState } from "react";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

import Logo from "../assets/logo";
import LogoMobile from "../assets/logomobile";
import ServiceArea from "../assets/servicearea";
import { Box } from "@mui/material";
import Legal from "../assets/legal";
import Document from "../assets/document";
import MenuComponent from "./MenuComponent";
import { Facebook, Instagram, Twitter } from "@mui/icons-material";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import News from "../assets/news";
import Library from "../assets/library";
import Benefits from "../assets/benefits";
import TalkToUs from "../assets/talktous";
import Accessible from "../assets/accessible";
import axios from "axios";
import { API_URL, ALL_CATEGORIES, MATERIAL_CATEGORIES, buildQuery, isAllCategories } from "../utils/api";

import Weight from "../assets/weight.";

function Header({ isMobile }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();

    const [newsCategories, setNewsCategories] = useState([]);
    const [text, setText] = useState(searchParams.get("search") || "");

    const currentSearch = searchParams.get("search") || "";
    const currentCategorie = searchParams.get("categorie") || ALL_CATEGORIES;

    // paginas que ja possuem listagem propria: o header filtra a pagina atual
    const onNews = location.pathname === "/noticias" || location.pathname === "/juridico";
    const onMaterials = location.pathname === "/materiais";
    const filtersCurrentPage = onNews || onMaterials;

    // mantem o campo em sincronia quando a URL muda (ex.: voltar no navegador)
    useEffect(() => {
        setText(currentSearch);
    }, [currentSearch]);

    useEffect(() => {
        axios.get(`${API_URL}/categories`, {
            headers: { "Content-Type": "application/json;charset=utf-8" },
            crossDomain: true,
        }).then(resp => {
            const sorted = [...resp.data]
                .map((cat) => ({ ...cat, name: String(cat.name || "").trim() }))
                .filter((cat) => cat.name)
                .sort((a, b) => a.name.localeCompare(b.name, "pt-BR"));
            setNewsCategories(sorted);
        }).catch(() => setNewsCategories([]));
    }, []);

    /**
     * Aplica busca + categoria. Em /noticias, /juridico e /materiais filtra a propria
     * pagina (mantendo o usuario onde esta); nas demais leva para a busca avancada.
     */
    function applyFilters({ search, categorie }) {
        const params = {};
        if (search && search.trim()) params.search = search.trim();
        if (!isAllCategories(categorie)) params.categorie = categorie;

        // em /juridico a categoria e fixa; escolher outra leva para a listagem geral
        if (location.pathname === "/juridico" && params.categorie) {
            navigate(`/noticias${buildQuery(params)}`);
            return;
        }

        if (filtersCurrentPage) {
            setSearchParams(params);
            return;
        }

        navigate(`/busca-avancada${buildQuery(params)}`);
    }

    function handleSearchKeyDown(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            applyFilters({ search: e.target.value, categorie: currentCategorie });
        }
    }

    const searchPlaceholder = onMaterials
        ? "Buscar Materiais"
        : onNews
            ? "Buscar Notícias"
            : "Buscar no site";

    const showNewsCategories = !onMaterials;
    const showMaterialCategories = !onNews;

    return (
        <Fragment>
            <Toolbar
                sx={{ borderBottom: 1, borderColor: "divider", padding: 2 }}
            >
                <Link to="/" aria-label="Sindsep - Página inicial">
                    {!isMobile && <Logo />}
                    {isMobile && <LogoMobile />}
                </Link>
                {!isMobile && (
                    <Box
                        component="nav"
                        aria-label="Navegação principal"
                        color="inherit"
                        align="center"
                        display={"flex"}
                        justifyContent={"center"}
                        gap={3}
                        noWrap={true}
                        sx={{ flex: 1 }}
                    >
                        <Link
                            to="/servicos"
                            style={{
                                textDecoration: "none",
                            }}
                        >
                            <Box width={80}>
                                <Benefits />
                                <Typography
                                    fontFamily="Raleway"
                                    fontStyle="normal"
                                    fontWeight="600"
                                    fontSize="12px"
                                    lineHeight="14px"
                                    color="#010101"
                                >
                                    Benefícios
                                </Typography>
                            </Box>
                        </Link>

                        <Link
                            to="/materiais"
                            style={{
                                textDecoration: "none",
                            }}
                        >
                            <Box width={80}>
                                <Library />
                                <Typography
                                    fontFamily="Raleway"
                                    fontStyle="normal"
                                    fontWeight="600"
                                    fontSize="12px"
                                    lineHeight="14px"
                                    color="#010101"
                                >
                                    Biblioteca de Materiais
                                </Typography>
                            </Box>
                        </Link>
                        <Link
                            to="/juridico"
                            style={{
                                textDecoration: "none",
                            }}
                        >
                            <Box width={80}>
                                <Legal />
                                <Typography
                                    fontFamily="Raleway"
                                    fontStyle="normal"
                                    fontWeight="600"
                                    fontSize="12px"
                                    lineHeight="14px"
                                    color="#010101"
                                >
                                    Consulta Jurídica
                                </Typography>
                            </Box>
                        </Link>
                        <Link
                            to="/noticias"
                            style={{
                                textDecoration: "none",
                            }}
                        >
                            <Box width={80}>
                                <News />
                                <Typography
                                    fontFamily="Raleway"
                                    fontStyle="normal"
                                    fontWeight="600"
                                    fontSize="12px"
                                    lineHeight="14px"
                                    color="#010101"
                                >
                                    Notícias
                                </Typography>
                            </Box>
                        </Link>
                        <a
                            href="https://www.areaprivada.prefeitura.sp.gov.br/PortalPMSP/PortalPMSP/Portal/PMSPprt001.tp"
                            target={"_blank"}
                            rel="noreferrer"
                            style={{
                                textDecoration: "none",
                            }}
                        >
                            <Box width={60}>
                                <Document />
                                <Typography
                                    fontFamily="Raleway"
                                    fontStyle="normal"
                                    fontWeight="600"
                                    fontSize="12px"
                                    lineHeight="14px"
                                    color="#010101"
                                >
                                    Holerite Eletrônico
                                </Typography>
                            </Box>
                            <span className="sr-only"> </span>
                        </a>
                        <Link
                            to="/diariooficial"
                            style={{
                                textDecoration: "none",
                            }}
                        >
                            <Box width={80}>
                                <Document />
                                <Typography
                                    fontFamily="Raleway"
                                    fontStyle="normal"
                                    fontWeight="600"
                                    fontSize="12px"
                                    lineHeight="14px"
                                    color="#010101"
                                >
                                    Diário Oficial
                                </Typography>
                            </Box>
                        </Link>
                        <Link
                            to="/galeria"
                            style={{
                                textDecoration: "none",
                            }}
                        >
                            <Box width={80}>
                                <ServiceArea />
                                <Typography
                                    fontFamily="Raleway"
                                    fontStyle="normal"
                                    fontWeight="600"
                                    fontSize="12px"
                                    lineHeight="14px"
                                    color="#010101"
                                >
                                    Galeria de Fotos
                                </Typography>
                            </Box>
                        </Link>
                        <a
                            href="https://www.escolasindsep.com.br"
                            target={"_blank"}
                            rel="noreferrer"
                            style={{
                                textDecoration: "none",
                            }}
                        >
                            <Box width={90}>
                                <TalkToUs />
                                <Typography
                                    fontFamily="Raleway"
                                    fontStyle="normal"
                                    fontWeight="600"
                                    fontSize="12px"
                                    lineHeight="14px"
                                    color="#010101"
                                    whiteSpace={"pre-line"}
                                >
                                    Escola de formação
                                </Typography>
                            </Box>
                            <span className="sr-only"> </span>
                        </a>
                        
                        <Link
                            to="/wellhub"
                            style={{
                                textDecoration: "none",
                            }}
                        >
                            <Box width={80}>
                                <Weight />
                                <Typography
                                    fontFamily="Raleway"
                                    fontStyle="normal"
                                    fontWeight="600"
                                    fontSize="12px"
                                    lineHeight="14px"
                                    color="#010101"
                                >
                                    WellHub Gympass
                                </Typography>
                            </Box>
                        </Link>
                    </Box>
                )}
                {!isMobile && (
                    <a
                        href="https://sindicalizacao.sindsep-sp.org.br"
                        target={"_blank"}
                        rel="noreferrer"
                        style={{
                            textDecoration: "none",
                            backgroundColor: "#C81E1E",
                            borderRadius: 100,
                            color: "#FFFFFF",
                            padding: "9px 19px",
                            fontFamily: "Raleway",
                            fontStyle: "normal",
                            fontWeight: "600",
                            fontSize: "16px",
                            lineHeight: "20px",
                            display: "inline-block",
                        }}
                    >
                        SINDICALIZAÇÃO ON-LINE
                        <span className="sr-only"> </span>
                    </a>
                )}

                {isMobile && (
                    <a
                        href="https://sindicalizacao.sindsep-sp.org.br"
                        target={"_blank"}
                        rel="noreferrer"
                        style={{
                            textDecoration: "none",
                            display: "flex",
                            justifyContent: "flex-end",
                            borderRadius: 100,
                            color: "#C81E1E",
                            padding: "10px",
                            fontFamily: "Raleway",
                            fontStyle: "normal",
                            fontWeight: "600",
                            fontSize: "12px",
                            lineHeight: "14px",
                            marginLeft: 6,
                            maxWidth: "30%",
                        }}
                    >
                        SINDICALIZAÇÃO ON-LINE
                        <span className="sr-only"> </span>
                    </a>
                )}
            </Toolbar>
            {isMobile && (
                <Box>
                    <Box
                        component="nav"
                        aria-label="Navegação principal"
                        color="inherit"
                        align="center"
                        display={"flex"}
                        justifyContent={"center"}
                        gap={2}
                        noWrap={true}
                        paddingX={4}
                    >
                        <Link
                            to="/servicos"
                            style={{
                                textDecoration: "none",
                            }}
                        >
                            <Box width={80}>
                                <Benefits />
                                <Typography
                                    fontFamily="Raleway"
                                    fontStyle="normal"
                                    fontWeight="600"
                                    fontSize="12px"
                                    lineHeight="14px"
                                    color="#010101"
                                >
                                    Benefícios e Convênios
                                </Typography>
                            </Box>
                        </Link>
                        <Link
                            to="/materiais"
                            style={{
                                textDecoration: "none",
                            }}
                        >
                            <Box width={80}>
                                <Library />
                                <Typography
                                    fontFamily="Raleway"
                                    fontStyle="normal"
                                    fontWeight="600"
                                    fontSize="12px"
                                    lineHeight="14px"
                                    color="#010101"
                                >
                                    Biblioteca de Materiais
                                </Typography>
                            </Box>
                        </Link>
                        <Link
                            to="/juridico"
                            style={{
                                textDecoration: "none",
                            }}
                        >
                            <Box width={70}>
                                <Legal />
                                <Typography
                                    fontFamily="Raleway"
                                    fontStyle="normal"
                                    fontWeight="600"
                                    fontSize="12px"
                                    lineHeight="14px"
                                    color="#010101"
                                >
                                    Consulta Jurídica
                                </Typography>
                            </Box>
                        </Link>
                        <a
                            href="https://api.whatsapp.com/send?phone=5511970255497"
                            target={"_blank"}
                            rel="noreferrer"
                            style={{
                                textDecoration: "none",
                            }}
                        >
                            <Box width={70}>
                                <TalkToUs />
                                <Typography
                                    fontFamily="Raleway"
                                    fontStyle="normal"
                                    fontWeight="600"
                                    fontSize="12px"
                                    lineHeight="14px"
                                    color="#010101"
                                    whiteSpace={"pre-line"}
                                >
                                    {"Fale\n Conosco"}
                                </Typography>
                            </Box>
                            <span className="sr-only"> </span>
                        </a>
                    </Box>
                    <Box
                        color="inherit"
                        align="center"
                        display={"flex"}
                        justifyContent={"center"}
                        gap={3}
                        noWrap={true}
                        sx={{ flex: 1 }}
                    >
                        <Link
                            to="/noticias"
                            style={{
                                textDecoration: "none",
                            }}
                        >
                            <Box width={80}>
                                <News />
                                <Typography
                                    fontFamily="Raleway"
                                    fontStyle="normal"
                                    fontWeight="600"
                                    fontSize="12px"
                                    lineHeight="14px"
                                    color="#010101"
                                >
                                    Notícias
                                </Typography>
                            </Box>
                        </Link>
                        <a
                            href="https://www.areaprivada.prefeitura.sp.gov.br/PortalPMSP/PortalPMSP/Portal/PMSPprt001.tp"
                            target={"_blank"}
                            rel="noreferrer"
                            style={{
                                textDecoration: "none",
                            }}
                        >
                            <Box width={60}>
                                <Document />
                                <Typography
                                    fontFamily="Raleway"
                                    fontStyle="normal"
                                    fontWeight="600"
                                    fontSize="12px"
                                    lineHeight="14px"
                                    color="#010101"
                                >
                                    Holerite Eletrônico
                                </Typography>
                            </Box>
                            <span className="sr-only"> </span>
                        </a>
                        <Link
                            to="/diariooficial"
                            style={{
                                textDecoration: "none",
                            }}
                        >
                            <Box width={80}>
                                <Document />
                                <Typography
                                    fontFamily="Raleway"
                                    fontStyle="normal"
                                    fontWeight="600"
                                    fontSize="12px"
                                    lineHeight="14px"
                                    color="#010101"
                                >
                                    Diário Oficial da Cidade
                                </Typography>
                            </Box>
                        </Link>
                        
                        <Link
                            to="/wellhub"
                            style={{
                                textDecoration: "none",
                            }}
                        >
                            <Box width={80}>
                                <Weight />
                                <Typography
                                    fontFamily="Raleway"
                                    fontStyle="normal"
                                    fontWeight="600"
                                    fontSize="12px"
                                    lineHeight="14px"
                                    color="#010101"
                                >
                                    WellHub Gympass
                                </Typography>
                            </Box>
                        </Link>
                    </Box>
                </Box>
            )}
            <Toolbar
                component="nav"
                aria-label="Barra de ferramentas"
                variant="dense"
                sx={{ justifyContent: "space-between", overflowX: "auto" }}
            >
                <MenuComponent />
                {!isMobile && (
                    <Box
                        align="center"
                        display={"flex"}
                        justifyContent="center"
                        sx={{ flex: 1 }}
                    >
                        <Box maxWidth={"50vw"} width={"100%"} style={{ display: "flex", gap: 8, alignItems: "center" }}>
                            <input
                                id="header-search"
                                type="search"
                                className="header-search-input"
                                name="busca"
                                aria-label={searchPlaceholder}
                                placeholder={searchPlaceholder}
                                value={text}
                                onChange={(e) => setText(e.target.value)}
                                onKeyDown={handleSearchKeyDown}
                                style={{ flex: 1, minWidth: 0 }}
                            />
                            <select
                                id="header-categories"
                                className="header-search-select"
                                value={currentCategorie}
                                onChange={(e) => applyFilters({ search: text, categorie: e.target.value })}
                                aria-label="Filtrar por categoria"
                            >
                                <option value={ALL_CATEGORIES}>TODAS AS CATEGORIAS</option>
                                {showNewsCategories && (
                                    <optgroup label="Notícias">
                                        {newsCategories.map((cat) => (
                                            <option key={cat.name} value={cat.name}>{cat.name}</option>
                                        ))}
                                    </optgroup>
                                )}
                                {showMaterialCategories && (
                                    <optgroup label="Materiais">
                                        {MATERIAL_CATEGORIES.map((cat) => (
                                            <option key={cat.id} value={String(cat.id)}>{cat.name}</option>
                                        ))}
                                    </optgroup>
                                )}
                            </select>
                        </Box>
                    </Box>
                )}
                {isMobile && (
                    <Box
                        align="center"
                        display={"flex"}
                        justifyContent="center"
                        sx={{ flex: 1 }}
                    ></Box>
                )}
                <a
                    href="https://www.facebook.com/sindsep"
                    target={"_blank"}
                    rel="noreferrer"
                    aria-label="Facebook do Sindsep "
                    style={{ marginRight: 4 }}
                >
                    <Facebook style={{ color: "#C81E1E" }} />
                </a>
                <a
                    href="https://www.instagram.com/sindsepsp"
                    target={"_blank"}
                    rel="noreferrer"
                    aria-label="Instagram do Sindsep "
                    style={{ marginRight: 4 }}
                >
                    <Instagram style={{ color: "#C81E1E" }} />
                </a>
                <a
                    href="https://twitter.com/sindsep"
                    target={"_blank"}
                    rel="noreferrer"
                    aria-label="Twitter do Sindsep "
                    style={{ marginRight: 4 }}
                >
                    <Twitter style={{ color: "#C81E1E" }} />
                </a>

                <Box
                    marginLeft={2}
                    backgroundColor="#004F8F"
                    borderRadius={999}
                    width="20px"
                    height="20px"
                    aria-hidden="true"
                >
                    <Accessible />
                </Box>
                {!isMobile && (
                    <Typography
                        fontFamily="Raleway"
                        fontStyle="normal"
                        fontWeight="400"
                        fontSize="14px"
                        lineHeight="13px"
                        color="#004F8F"
                        marginX={1}
                        whiteSpace={"pre-line"}
                    >
                        {"Site\n acessível"}
                    </Typography>
                )}
            </Toolbar>
            {isMobile && (
                <Toolbar
                    component="div"
                    variant="dense"
                    sx={{ justifyContent: "space-between", overflowX: "auto" }}
                >
                    <Box
                        align="center"
                        display={"flex"}
                        justifyContent="center"
                        sx={{ flex: 1 }}
                    >
                        <Box maxWidth={"80vw"} width={"100%"}>
                            <input
                                id="header-search-mobile"
                                type="search"
                                className="header-search-input"
                                name="busca"
                                aria-label={searchPlaceholder}
                                placeholder={searchPlaceholder}
                                value={text}
                                onChange={(e) => setText(e.target.value)}
                                onKeyDown={handleSearchKeyDown}
                                style={{ width: "100%" }}
                            />
                        </Box>
                    </Box>
                </Toolbar>
            )}
        </Fragment>
    );
}

export default Header;
